
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile/campaign/detail",
      function () {
        return require("private-next-pages/mobile/campaign/detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile/campaign/detail"])
      });
    }
  